import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@els/els-react--button';
import { Modal } from '@els/els-react--modal';
import { remoteAccessDialogTitles } from '../../RemoteAccessDialogConstants';

import './LoginPromptDialog.scss';

function LoginPromptDialog(props) {
  const { selfClose, onSignInClick } = props;

  return (
    <Modal
      className="remote-access-login-prompt-dialog"
      label={remoteAccessDialogTitles.CHOICE}
      onClose={selfClose}
      id="remote-access-login-prompt-modal">
      <div className="remote-access-login-prompt-dialog__header">
        <h4>{remoteAccessDialogTitles.CHOICE}</h4>
      </div>
      <div className="remote-access-login-prompt-dialog__content">
        The activation of remote access can be done when you are signed in. Please sign in and try again.
      </div>
      <div className="remote-access-login-prompt-dialog__footer">
        <div className="els-btn-group-right">
          <Button
            data-e2e="remote-access-login-prompt-cancel"
            type="tertiary"
            size="small"
            onClick={selfClose}
            className="e2e-remote-access-login-prompt-dialog-cancel">
            Cancel
          </Button>
          <Button
            data-e2e="remote-access-login-prompt-sign-in"
            type="primary"
            size="small"
            onClick={() => {
              onSignInClick();
              selfClose();
            }}
            className="e2e-remote-access-login-prompt-dialog-sign-in">
            Sign in
          </Button>
        </div>
      </div>
    </Modal>
  );
}

LoginPromptDialog.defaultProps = {
  onSignInClick: () => {},
};

LoginPromptDialog.propTypes = {
  selfClose: PropTypes.func,
  onSignInClick: PropTypes.func,
};

export default LoginPromptDialog;
